












































import Vue from 'vue';
import Header from './components/Header.vue';
import Login from './components/Login.vue';
import ApiListTable from './components/ApiListTable.vue';
import Editor from './components/Editor.vue';
import FilterInput from './components/FilterInput.vue';
import Result from './components/Result.vue';
import Uploader from './components/Uploader.vue';
import { Auth } from '../generated/core/Auth';
import { mapActions, mapState, mapGetters } from 'vuex';
import { LocalStorage } from '../generated';

export default Vue.extend({
  name: 'App',
  components: {
    Header,
    Login,
    ApiListTable,
    Editor,
    FilterInput,
    Result,
    Uploader,
  },
  computed: {
    ...mapState([
      'query',
      'apis',
      'renderApi',
      'response',
      'isResponseErrorOccured',
    ]),
    ...mapGetters(['filteredApis']),
  },
  data() {
    return {
      expandsEditor: false,
    };
  },
  methods: {
    ...mapActions([
      'setQuery',
      'setApis',
      'setRenderApi',
      'request',
      'clearResponse',
    ]),
  },
  async mounted() {
    LocalStorage.deleteAccessToken();
    LocalStorage.deleteRefreshToken();
    Auth.onErrorHandler = async result => Promise.resolve();
  },
});
